<template>
  <div class="index">
    <div class="wrp">
      <a-spin wrapperClassName="main-col" :spinning="uploading" tip="上传中...">
        <a-upload-dragger
          :data="{ spec_id: specId, fair_level: 1 }"
          class="main-col"
          name="file"
          :disabled="isDisabled"
          :multiple="true"
          accept="image/*"
          :beforeUpload="beforeUpload"
        >
          <p class="ant-upload-text">点击或将图片拖入开始制作</p>
          <p class="ant-upload-hint">支持扩展名：.jpg .png .bmp</p>
          <div class="upload-way">
            <div class="upload-way-item">
              <div class="upload-way-icon">
                <img src="../assets/webUpload.png" alt />
              </div>
              <div>电脑上传</div>
            </div>
            <div class="upload-way-item" @click.stop="showWapUpload">
              <div class="upload-way-icon">
                <img src="../assets/wapUpload.png" alt />
              </div>
              <div>手机上传</div>
            </div>
          </div>
        </a-upload-dragger>
      </a-spin>
      <sideBar
        class="sidebar-col"
        title="我的照片"
        subTitle="照片仅保存7天"
        iconType="folder-open"
      >
        <div class="flex sidebar-con">
          <login
            :isLogin="isLogin"
            :toggleLoginFn="toggleLoginFn"
            :loginModal="loginModal"
            :loginBtnFn="loginBtnFn"
            :cancel="cancel"
            type="single"
          />
        </div>
      </sideBar>
    </div>
    <rule
      v-if="rulePopVisible"
      :rulePopVisible="rulePopVisible"
      :ok="ok"
      :autoSpec="false"
    ></rule>
    <wapUpload
      @handleResult="handleResult"
      @cancel="wapUploadCancel"
      :isVisible="isWapUploadVisible"
      source_page="makePic"
      :makePicData="{ spec_id: specId, fair_level: 1 }"
    />
    <footerF />
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import sideBar from "@/components/sidebar.vue";
import rule from "@/components/rule.vue";
import login from "@/components/login.vue";
import wapUpload from "@/components/wapUpload.vue";
import footerF from "@/components/footer.vue";
import { setCookie, getCookie } from "../utils/cookie";
import { getMakerPic } from "@/utils/api";
export default {
  data() {
    return {
      isDisabled: false,
      isLogin: false,
      loginModal: false,
      rulePopVisible: false,
      specId: null,
      uploading: false,
      isWapUploadVisible: false,
    };
  },
  metaInfo() {
    return {
      title: "证件照片在线制作（专业版）",
      meta: [
        {
          name: "keywords",
          content:
            "证件照合规性在线检测，证件照在线检测，美国签证，国考，英语四六级",
        },
        {
          name: "description",
          content:
            "全球证件照合规性检测&证件照制作平台，包含300多种规格尺寸，一键完成证件照合规性检测及制作。支持四六级考试，教师资格证，驾驶证，毕业证等照片，包含美国、泰国、日本、新加坡、马来西亚60多个国家的签证。",
        },
      ],
    };
  },
  //   beforeRouteEnter: (to, from, next) => {
  //     next((vm) => {
  //       sessionStorage.setItem("enterRecord", "maker2");
  //     });
  //   },
  beforeMount() {
    let self = this;
    var _hmt = _hmt || [];
    var hm = document.getElementById("baodu-hm");
    hm.src = "https://hm.baidu.com/hm.js?bd881a102f6a3f84780a2ccbe7b65eb2";
    let token = this.$route.query.token;
    let type = this.$route.query.type;
    if (type) {
      setCookie("lq-login-type", type, 1);
    }
    if (token) {
      setCookie("lq-handlephoto-token", token, 1);
    }
    if (getCookie("lq-handlephoto-token")) {
      this.isLogin = true;
    }
  },
  components: {
    sideBar,
    rule,
    login,
    wapUpload,
    footerF,
  },
  methods: {
    ...mapMutations(["setNavState"]),
    showWapUpload(e) {
      this.isWapUploadVisible = true;
    },
    wapUploadCancel() {
      this.isWapUploadVisible = false;
    },
    loginBtnFn() {
      this.loginModal = true;
    },
    toggleLoginFn(bol) {
      this.isLogin = bol;
    },
    cancel() {
      this.loginModal = false;
    },
    ok() {
      this.rulePopVisible = false;
      this.specId = JSON.parse(sessionStorage.getItem("ruleItemInfo")).spec_id;
      this.isDisabled = false;
      this.handleUpload();
    },
    beforeUpload(file) {
      let _this = this;
      const isLt2M = file.size / 1024 / 1024 < 10;
      this.uploading = true;
      if (!isLt2M) {
        this.$message.error("图片必须小于10M!");
        return isLt2M;
      }
      var reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onloadend = function () {
        _this.file = file;
        _this.rulePopVisible = true;
      };
      return false;
    },
    handleUpload(info) {
      Promise.all([
        getMakerPic({
          file: this.file,
          spec_id: this.specId,
          fair_level: 0,
        }),
        getMakerPic({
          file: this.file,
          spec_id: this.specId,
          fair_level: 1,
        }),
      ]).then(([{ result: noBeautyInfo }, { result: beautyInfo }]) => {
        const {
          wm_url: no_wm_url,
          key: no_key,
          origin_key: no_origin_key,
        } = noBeautyInfo;
        this.handleData(
          Object.assign({}, beautyInfo, { no_wm_url, no_key, no_origin_key })
        );
      });
    },
    // base64直接转换File不兼容IE
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    blobToFile(theBlob, fileName = "证件照") {
      theBlob.lastModifiedDate = new Date();
      theBlob.name = fileName;
      return theBlob;
    },
    handleResult(res) {
      this.isWapUploadVisible = false;
      this.beforeUpload(this.blobToFile(this.dataURLtoBlob(res.data)));
    },
    handleData(result) {
      sessionStorage.setItem("makePicInfo", JSON.stringify(result));
      this.uploading = false;
      this.$router.push("/process");
    },
  },
};
</script>
<style scoped>
.sidebar-con {
  height: calc(100% - 44px);
}
.upload-way {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}
.upload-way-item {
  margin-right: 64px;
}
.upload-way-item:last-child {
  margin-right: 0;
}
.upload-way-icon {
  width: 80px;
  height: 80px;
  line-height: 80px;
  background: #ffffff;
  border-radius: 8px;
  margin-bottom: 12px;
}
.upload-way-icon img {
  width: 41px;
}
.mask {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: #ebedf0;
  text-align: center;
  line-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>